import { mapProps } from 'core/libs/recompose';

import { getPublisherScope } from 'core/utils/url-helper';


function resolveProps(props) {
  const {
    ads,
    name,
    puids,
    siteId,
    blockId,
    options,
    manualPuids,
    requestHeaders: {
      host,
      'x-split': xSplit,
    },
    splitTest,
  } = props;

  const resolvedAds = ads || {};
  const resolvedBanner = (resolvedAds.banners || {})[name] || {};

  const resolvedSiteId = siteId || resolvedAds.siteId;
  const resolvedMisc = splitTest && splitTest.miscTypes[xSplit];
  const resolvedBlockId = blockId || resolvedBanner.id;


  const resolvedBannerOptions = {
    ...puids,
    ...manualPuids,
    ...resolvedBanner.options,
    ...options,
  };

  return {
    ...props,
    siteId: resolvedSiteId,
    blockId: resolvedBlockId,
    options: resolvedBannerOptions,
    sspOptions: {
      'begun-auto-pad': resolvedSiteId,
      'begun-block-id': resolvedBlockId,
      'begun-misc': resolvedMisc,
      publisher_uid_scope: getPublisherScope(host),
    },
  };
}

export default mapProps(resolveProps);
